import React from "react"
import "./styles.css"
import { Container, Row, Col } from "react-bootstrap"
import ColoredLine from "./ColoredLine"

const date = new Date()
const today = date.toLocaleDateString()
const whichDay = date.getDay()

const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
]

export default function () {
  return (
    <div>
      <p
        className="display-3"
        style={{
          paddingTop: 30,
          fontFamily: '"InkedBones", "serif" ',
          // fontSize: "60px",
          // font: "-moz-initial",
        }}
      >
        Debajit Deb
      </p>

      <Container>
        <Row>
          <Col xs>
            <span>{days[whichDay]}, </span>
            <span>{today}</span>
          </Col>
          <Col xs={{ order: 12 }}>(+91)9365112510</Col>
        </Row>
      </Container>
      <ColoredLine lineColor="#30475e" />
    </div>
  )
}
